import { render, staticRenderFns } from "./msGridViewer.vue?vue&type=template&id=35c60960&scoped=true"
import script from "./msGridViewer.vue?vue&type=script&lang=js"
export * from "./msGridViewer.vue?vue&type=script&lang=js"
import style0 from "./msGridViewer.vue?vue&type=style&index=0&id=35c60960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c60960",
  null
  
)

export default component.exports